import { z } from "zod";

export const ActivitySchema = z.object({
    id: z.number().positive().min(1),
    accountId: z.number().positive().min(1),
    projectId: z.number().positive().min(1),
    name: z.string().max(128),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
    description: z.string().max(4096).nullable().optional(),
    ownerId: z.number().positive().min(1),
    startDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    endDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    deleted: z.boolean(),
    closed: z.boolean(),
});


export type Activity = z.infer<typeof ActivitySchema>;
